import React from 'react';

const SIZE = {
  xs: 'w-3 h-3 border-2',
  sm: 'w-4 h-4 border-2',
  md: 'w-6 h-6 border-2',
  lg: 'w-8 h-8 border-[3px]',
};

// `inline` usa currentColor (pra ficar dentro de botões);
// `overlay` cobre o pai com backdrop claro semitransparente.
const Spinner = ({ size = 'md', variant = 'inline', className = '' }) => {
  const sz = SIZE[size] || SIZE.md;
  const ring = (
    <span
      className={`inline-block ${sz} border-current border-t-transparent rounded-full animate-spin ${className}`}
      role="status"
      aria-label="Carregando"
    />
  );

  if (variant === 'overlay') {
    return (
      <div className="absolute inset-0 flex items-center justify-center bg-white/70 backdrop-blur-sm z-10">
        <span className="text-primary">{ring}</span>
      </div>
    );
  }

  return ring;
};

export default Spinner;
